function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("metadata", {
  id: "metadata102"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", {
  id: "defs59"
}, /*#__PURE__*/React.createElement("style", {
  id: "style57"
}, "\n      .cls-1{fill:#e74b3c;}\n      .cls-2{fill:#607d8b;}\n      .cls-3{fill:#b0bec5;}\n      .cls-4{fill:#2c3e50;}\n      #dops-spinner {\n        animation: loading-spinner 2s linear infinite;\n      }\n\n      #circle1 {\n        -webkit-animation: bounce1 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) infinite alternate;\n        animation: bounce1 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) infinite alternate;\n      }\n\n      #circle2 {\n        -webkit-animation: bounce2 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) infinite alternate;\n        animation: bounce2 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) infinite alternate;\n      }\n\n      #circle3 {\n        -webkit-animation: bounce3 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) infinite alternate;\n        animation: bounce3 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) infinite alternate;\n      }\n\n      #circle4 {\n        -webkit-animation: bounce4 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) infinite alternate;\n        animation: bounce4 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) infinite alternate;\n      }\n\n      @-webkit-keyframes bounce1 {\n        0% {\n          -webkit-transform: translate(0,0);\n          transform: translate(0,0);\n        }\n        100% {\n          -webkit-transform: translate(-25px,-25px);\n          transform: translate(-25px,-25px);\n        }\n      }\n\n      @keyframes bounce1 {\n        0% {\n          -webkit-transform: translate(0,0);\n          transform: translate(0,0);\n        }\n        100% {\n          -webkit-transform: translate(-25px,-25px);\n          transform: translate(-25px,-25px);\n        }\n      }\n\n      @-webkit-keyframes bounce2 {\n        0% {\n          -webkit-transform: translate(0,0);\n          transform: translate(0,0);\n        }\n        100% {\n          -webkit-transform: translate(25px,-25px);\n          transform: translate(25px,-25px);\n        }\n      }\n\n      @keyframes bounce2 {\n        0% {\n          -webkit-transform: translate(0,0);\n          transform: translate(0,0);\n        }\n        100% {\n          -webkit-transform: translate(25px,-25px);\n          transform: translate(25px,-25px);\n        }\n      }\n\n      @-webkit-keyframes bounce3 {\n        0% {\n          -webkit-transform: translate(0,0);\n          transform: translate(0,0);\n        }\n        100% {\n          -webkit-transform: translate(-25px,25px);\n          transform: translate(-25px,25px);\n        }\n      }\n\n      @keyframes bounce3 {\n        0% {\n          -webkit-transform: translate(0,0);\n          transform: translate(0,0);\n        }\n        100% {\n          -webkit-transform: translate(-25px,25px);\n          transform: translate(-25px,25px);\n        }\n      }\n\n      @-webkit-keyframes bounce4 {\n        0% {\n          -webkit-transform: translate(0,0);\n          transform: translate(0,0);\n        }\n        100% {\n          -webkit-transform: translate(25px,25px)\n          transform: translate(25px,25px);\n        }\n      }\n\n      @keyframes bounce4 {\n        0% {\n          -webkit-transform: translate(0,0);\n          transform: translate(0,0);\n        }\n        100% {\n          -webkit-transform: translate(25px,25px);\n          transform: translate(25px,25px);\n        }\n      }\n\n      @keyframes loading-spinner {\n        from {\n          transform: rotate(0deg);\n        }\n        to {\n          transform: rotate(360deg);\n        }\n      }\n    "));

var _ref4 = /*#__PURE__*/React.createElement("title", {
  id: "title61"
}, "dops");

var SvgDotsAnim = function SvgDotsAnim(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 260,
    width: 260,
    viewBox: "0 0 260 260",
    "data-name": "Layer 1",
    id: "dops-spinner",
    ref: svgRef
  }, props), _ref2, _ref3, title === undefined ? _ref4 : title ? /*#__PURE__*/React.createElement("title", {
    id: "title61"
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e74b3c",
      strokeWidth: 0
    },
    id: "circle1",
    ry: 40,
    rx: 40,
    height: 80,
    width: 80,
    y: 50,
    x: 50,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#607d8b",
      strokeWidth: 0
    },
    id: "circle2",
    ry: 40,
    rx: 40,
    height: 80,
    width: 80,
    y: 50,
    x: 130,
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#b0bec5",
      strokeWidth: 0
    },
    id: "circle3",
    ry: 40,
    rx: 40,
    height: 80,
    width: 80,
    y: 130,
    x: 50,
    className: "cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2c3e50",
      strokeWidth: 0
    },
    id: "circle4",
    ry: 40,
    rx: 40,
    height: 80,
    width: 80,
    y: 130,
    x: 130,
    className: "cls-4"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDotsAnim, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dots-anim.c81cdf49.svg";
export { ForwardRef as ReactComponent };